'use client';

import React from 'react';
import { LearnSectionLabel } from './LearnSectionLabel';

export const LearnPresentedBy: React.FC<{ logo?: string }> = ({ logo }) => {
  if (!logo) return null;

  return (
    <div className="flex items-center justify-between gap-4 border-t border-white/10 pt-4 lg:mb-5 lg:block lg:border-b lg:border-t-0 lg:pb-5 lg:pt-0 lg:text-center">
      <LearnSectionLabel className="lg:mb-3" label="Presented By" />
      <img alt="Presented by" className="w-auto max-w-[60%] max-h-7 lg:max-h-8 lg:max-w-full" src={logo} />
    </div>
  );
};

export default LearnPresentedBy;
